import FormFields from 'pages/components/FormFields';
import ContractSignature from 'pages/components/Molecules/ContractSignature';
import Section from 'pages/components/Section';
import { useEffect, useState } from 'react';
import useForm from 'pages/components/Form/useForm';
import { FormFieldsConfig } from 'pages/components/Form/FormEntities';

import FileOpenIcon from '@mui/icons-material/FileOpen';
import { Grid2, useMediaQuery, useTheme } from '@mui/material';
import { getUserData, signUserContract } from 'Application/User/UserService';

export default function Contract({
  isSigned,
  disabled,
  contractUrl,
  setUserData,
  userId,
}: any) {
  const [contractModalOpen, setContractModalOpen] = useState(false);
  function handleContractButton() {
    if(!disabled)
    setContractModalOpen(true);
  }
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const contractFormConfig = {
    contract: {
      default: isSigned,
      constraints: ['isTrue'],
    },
  } as FormFieldsConfig;

  const {
    errors,
    values,
    options,
    handleInputChange,
    isValidForm,
    formatErrorObject,
    Form,
  } = useForm(contractFormConfig, true);

  useEffect(() => {
    isValidForm();
  }, []);

  useEffect(() => {
    if (isValidForm() && !isSigned) {
      signUserContract(getUpdateSignatureRequest(values).contract)
      .then(
        (res) => {
          getUserData(userId).then((res) => {
            setUserData(res);
          }
          );
        },
      );
    }
  }, [values.contract]);

  return (
    <Section title={'contract'}>
      {/* <Form onSubmit={handleSubmit}> */}
      <Grid2
        display={'grid'}
        width={'100%'}
        gridTemplateColumns={isMobile ? '1fr' : '1fr 1fr'}
      >
        <Grid2>
          <FormFields.CheckBox
            name="contract"
            value={values.contract !== false}
            onChange={handleInputChange}
            disabled={true}
            {...formatErrorObject(errors.contract)}
          />
        </Grid2>
        <Grid2
          container
          sx={{
            alignSelf: 'end',
            justifySelf: 'end',
            position: 'relative',
          }}
          onClick={handleContractButton}
        >
          <ContractIcon name="expand-contract" isError={!!errors.contract} disabled={disabled} />
        </Grid2>
        <ContractSignature
          name="contract"
          onSignatureSave={handleInputChange}
          tradKey="creditor"
          contractUrl={contractUrl}
          open={contractModalOpen}
          isSigned={values.contract !== false}
          setOpen={setContractModalOpen}
        />
      </Grid2>
    </Section>
  );
}

function ContractIcon({ isError, disabled, ...props }: any) {
  // if (disabled){
  //   const color
  //   return <FileOpenIcon
  //     sx={{
  //       position: 'absolute',
  //       backgroundColor: 'white',
  //       right: 0,
  //       bottom: 0,
  //       width: 'auto',
  //       height: '3em',
  //       aspectRatio: 'none',
  //       cursor: 'pointer',
  //       color: color,
  //       border: '2px solid ' + color,
  //       borderRadius: '10px',
  //       '&:hover': {
  //         color: 'blue',
  //         borderColor: 'blue',
  //       },
  //       '&:focus': {
  //         color: 'blue',
  //         borderColor: 'blue',
  //       },
  //     }}
  //     fontSize="large"
  //     {...props}
  //   />
  // }
  const color = disabled ? 'gray' : isError ? 'red' : 'black';

  const activeCss = !disabled
  ? {
      '&:hover': {
        color: 'blue',
        borderColor: 'blue',
      },
      '&:focus': {
        color: 'blue',
        borderColor: 'blue',
      },
  }
  : {}
  ; 

  return (
    <FileOpenIcon
      sx={{
        position: 'absolute',
        backgroundColor: 'white',
        right: 0,
        bottom: 0,
        width: 'auto',
        height: '3em',
        aspectRatio: 'none',
        cursor: 'pointer',
        color: color,
        border: '2px solid ' + color,
        borderRadius: '10px',
       ...activeCss
      }}
      fontSize="large"
      {...props}
    />
  );
}

function getUpdateSignatureRequest(values: any) {
  const updateSignatureRequest = new UpdateSignatureRequest(values.contract);
  return updateSignatureRequest;
}

class UpdateSignatureRequest {
  constructor(public contract: string) {}
}
